import React, { useEffect, useState } from "react";
import { detectMobileOs, getStoreUrlForOs, openMobileApp, MOBILE_APP_ANDROID_STORE_URL, MOBILE_APP_IOS_STORE_URL } from "../common/utils/mobileAppLink";
import loginLogo from "../assets/Loginpage_logo.png";
import "../styles/appRedirect.css";

const AppRedirect = () => {
  const [os] = useState(detectMobileOs());
  const [showStoreLinks, setShowStoreLinks] = useState(os === "other");

  useEffect(() => {
    openMobileApp({
      onAppNotInstalled: (detectedOs) => {
        setShowStoreLinks(true);
        const storeUrl = getStoreUrlForOs(detectedOs);
        if (storeUrl) {
          window.location.href = storeUrl;
        }
      },
    });
  }, []);

  return (
    <div className="app-redirect-outer">
      <div className="app-redirect-page">
        <img src={loginLogo} alt="BT Homecare" className="app-redirect-logo" />
        <h1 className="app-redirect-title">BT Homecare</h1>
        <p className="app-redirect-message">{os === "other" ? "Get the BT Homecare app on your mobile device." : "Redirecting you to the BT Homecare app..."}</p>
        <p className="app-redirect-hint">If the app is not installed, you will be redirected to the appropriate app store.</p>
        {showStoreLinks && (
          <div className="app-redirect-store-links">
            <a className="app-redirect-btn" href={MOBILE_APP_ANDROID_STORE_URL} target="_blank" rel="noreferrer">
              Get it on Google Play
            </a>
            <a className="app-redirect-btn" href={MOBILE_APP_IOS_STORE_URL} target="_blank" rel="noreferrer">
              Download on the App Store
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default AppRedirect;
